import React from 'react';
import EpiserverFormsBlock from '../platformui/EpiserverFormsBlock';

export default (props) => <EpiserverFormsBlock {...props} />;
